import React from 'react';
import {FormattedMessage} from 'react-intl';
import Icon  from 'containers/performance/img/speedometer-icon@2x.png';

const EmptyState = () => {
  return (
    <div className='bg-white rounded box-shadow-1 p3 center'>
      <div className='clearfix'>
        <div className='col-8 mx-auto'>
          <div className='center'>
            <img width='100px' className='my3' src={Icon} role='presentation' />
          </div>
          <div className='h1'>
            <FormattedMessage id="performance.One-on-ones with your leader"/>
          </div>
          <div className='h3 mt2 mb4 max-width-3 px3 mx-auto'>
            <FormattedMessage id="performance.Leaders benefit from feedback and support as much as any of their employees. With this feature, you can submit brief Check-Ins to your own leader to ensure that everyone has the chance to have frequent and productive one-on-ones. To get started, speak with your Collage administrator." />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;

